import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.$gray200};
  cursor: pointer;
  text-align: left;
  transition: box-shadow 0.15s ease;

  &:hover,
  &:focus {
    box-shadow: 0 2px 8px ${(props) => props.theme.$black}1f;
    outline: 0;
  }

  .card-location {
    color: ${(props) => props.theme.$gray700};
  }

  .task-card-count {
    padding: 0 6px;
    background: ${(props) => props.theme.$white};
    color: ${(props) => props.theme.$gray700};
  }

  .material-icons {
    font-size: 16px;
  }

  .badge-dark {
    font-size: 12px;
    background: ${(props) => props.theme.$steel_blue} !important;
  }
`;
